(function(){
    'use strict';

    angular
    .module('app')
    .controller('SlugconfigController', EnlaceconfigController)
 
    EnlaceconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function EnlaceconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.field = "";
        vm.update = function(){
            var j = JSON.parse($('#fieldconfig-value').val());

        	console.log(vm.limit);
			
            j.references["field"] = vm.field;
			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        }
        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
        		if(typeof vm.json.references.field!='undefined'){
                    vm.field = vm.json.references.field;
                }
        	}
        	vm.update();
        }
    } 

})();